// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"b43ba52e","186":"888b36e5","215":"e144ab95","372":"58ed5999","443":"aad6aef2","738":"237bef1a","841":"a7167eeb","851":"611d66ad","856":"b3661dc6"}[chunkId] + ".chunk.js";
};